import { render } from "./Fecha.vue?vue&type=template&id=10bf3848&scoped=true"
import script from "./Fecha.vue?vue&type=script&lang=js"
export * from "./Fecha.vue?vue&type=script&lang=js"

import "./Fecha.vue?vue&type=style&index=0&id=10bf3848&scoped=true&lang=css"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/QuoteAndBuy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bf3848"]])

export default __exports__